/**
 * The 10-row shimmer placeholder shown while a table is loading. Extracted from Table so that large
 * component stays under the file-length cap. Only the visible columns (`show !== false`) get a cell.
 */
export const renderTableSkeleton = (columns: { show?: boolean }[]): JSX.Element[] => {
	const rows: JSX.Element[] = [];

	for (let i = 1; i <= 10; i++) {
		rows.push(
			<tr key={`skeleton-row-${i}`}>
				{columns
					.filter((c) => c.show === true || c.show === undefined)
					.map((_item, colindex) => (
						<td
							key={`skeleton-${i}-${colindex}`}
							className="px-3 py-1.5 text-sm font-normal leading-6 duration-200 border-t border-border-light"
						>
							<div className="relative h-5 overflow-hidden">
								<div className="c-animated-background" />
							</div>
						</td>
					))}
			</tr>
		);
	}

	return rows;
};
